import { useState } from "react";
import {
  AmazonItemsGetAmazonItemsPostRequest,
  AmazonItemsApi,
  ResponseGetAmazonItemsListResponse,
  RequestGetAmazonItemsListRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetAmazonItems = () => {
  const [amazonItemsList, setAmazonItemsList] =
    useState<ResponseGetAmazonItemsListResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchAmazonItems = async (
    requestParams: RequestGetAmazonItemsListRequest
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: AmazonItemsGetAmazonItemsPostRequest = {
        req: requestParams,
      };

      const api = new AmazonItemsApi(config);
      const response = await api.amazonItemsGetAmazonItemsPost(request);
      setAmazonItemsList(response);
      return response;
    } catch (err) {
      setError("商品情報の取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { amazonItemsList, fetchAmazonItems, error, isLoading };
};
